<template>
  <div class="center">
    <vs-tabs alignment="center" v-model="active">
      <vs-tab label="Segurado"> </vs-tab>
      <vs-tab label="Corretora"> </vs-tab>
    </vs-tabs>
    <vs-table stripe :data="list">
      <template #thead>
        <vs-th> Data/Hora</vs-th>
        <vs-th> Código</vs-th>
        <vs-th> Canal</vs-th>
        <vs-th> Destinatário</vs-th>
        <vs-th> Status</vs-th>
        <vs-th> Log de erro</vs-th>
        <vs-th> Observação</vs-th>
        <vs-th> Ações</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.createdAt">
            {{ formatarData(tr.createdAt) }}
          </vs-td>

          <vs-td :data="tr.codigoMensagem">
            {{ tr.codigoMensagem }}
          </vs-td>

          <vs-td :data="tr.canal">
            {{ tr.canal }}
          </vs-td>

          <vs-td :data="tr.destinatario">
            {{ tr.destinatario }}
          </vs-td>

          <vs-td :data="hasError(tr)">
            <vs-chip :color="hasError(tr) ? 'danger' : 'success'">
              {{ hasError(tr) ? 'Erro' : 'Sucesso' }}
            </vs-chip>
          </vs-td>

          <vs-td v-if="hasError(tr)" :data="tr.historico">
            {{ tr.historico }}
          </vs-td>
          <vs-td v-else> </vs-td>

          <vs-td :data="tr.observacao">
            {{ tr.observacao }}
          </vs-td>
          <vs-td v-if="canShowResendButton">
            <vs-button
              @click="showResendConfirm(tr)"
              radius
              color="warning"
              icon="cached"
              type="filled"
              class="mr-2"
              v-tooltip="'Reenviar Mensagem'"
            />
          </vs-td>
          <vs-td v-else></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import messagingApi from '../../services/messaging.api';
import { MESSAGING_SUCCESS_STATUS } from '../../utils/constants';

export default {
  props: ['dadosProposta'],
  data() {
    return {
      historic: [],
      active: 0,
      tabs: {
        0: 'SEGURADO',
        1: 'CORRETORA',
      },
    };
  },
  mounted() {
    this.getHistorico();
  },
  computed: {
    list() {
      return this.historic.filter((item) => {
        return (
          item.tipoDestinatario &&
          item.tipoDestinatario.toUpperCase() === this.tabs[this.active]
        );
      });
    },
    canShowResendButton() {
      return this.$can('Reenviar Mensageria', 'Cotações');
    },
  },
  methods: {
    formatarData(data) {
      const dateObj = new Date(data);
      const dia = dateObj.getDate().toString().padStart(2, '0');
      const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const ano = dateObj.getFullYear();
      const horas = dateObj.getHours().toString().padStart(2, '0');
      const minutos = dateObj.getMinutes().toString().padStart(2, '0');
      const segundos = dateObj.getSeconds().toString().padStart(2, '0');
      return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
    },
    async getHistorico() {
      if (!this.dadosProposta || !this.dadosProposta.idApolice) {
        return;
      }
      this.historic = await messagingApi.getMessagingHistoryByPolicyId(
        this.dadosProposta.idApolice,
        this.dadosProposta.dadosCliente.idProspect,
      );
    },
    hasError(history) {
      return !MESSAGING_SUCCESS_STATUS.includes(history.historico);
    },
    resendMessage(message) {
      this.$vs.loading();
      const payload = {
        messagingHistoryId: message.idMensageriaFilaHistorico,
        channel: message.canal,
        receiverType: message.tipoDestinatario,
      };
      messagingApi.resendMessaging(payload).then((response) => {
        if (response.success) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Sucesso',
            text: 'Mensagem reenviada com sucesso',
            color: 'success',
          });
        }
      }).catch((err) => {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: err.message,
          color: 'danger',
        });
      }).finally(() => {
        this.$vs.loading.close();
        this.getHistorico();
      });
    },
    showResendConfirm(message) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Confirmar`,
        text: 'Tem certeza que deseja reenviar essa mensagem?',
        acceptText: 'Enviar',
        cancelText: 'Cancelar',
        style: 'z-index: 999999',
        accept: () => this.resendMessage(message),
      });
    },
  },
  watch: {},
};
</script>
<style>
.con-vs-dialog {
  z-index: 54000;
}

.tooltip {
  z-index: 54000;
}
</style>
